import { Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Portfoliu from "@/pages/Portfoliu";
import Header from "@/components/common/header/Header";
import Footer from "@/components/common/footer/Footer";
import WebDesign from "@/pages/WebDesign";
import ServerSideTracking from "@/pages/ServerSideTracking";
import ReclameVideo from "@/pages/online-marketing/ReclameVideo";
import VfxVideo from "@/pages/online-marketing/VfxVideo";
import Project from "@/pages/Project";
import Branding from "@/pages/branding/Branding";
import LogoDesign from "@/pages/branding/LogoDesing";
import VisualIdentity from "@/pages/branding/VisualIdentity";
import ManualBranding from "@/pages/branding/ManualBranding";
import OnlineMarketing from "@/pages/online-marketing/OnlineMarketing";
import SocialSetup from "@/pages/online-marketing/SocialSetup";
import Seo from "@/pages/online-marketing/Seo";
import Smm from "@/pages/online-marketing/Smm";
import NotFound from "@/pages/NotFound";
import Plan from "@/pages/Plan";
import Commerce from "@/pages/Commerce";
import Ecommerce from "@/pages/portfoliu/Ecommerce";
import BrandingPortfolio from "@/pages/portfoliu/BrandingPortfolio";  
import WebsiteuriDePrezentare from "@/pages/portfoliu/WebsiteuriDePrezentare";
import SMMcontent from "@/pages/portfoliu/SMMcontent";
import CCshopAdminRequest from "@/pages/CCshopAdminRequest";
import PachetSeoSmm from "@/pages/online-marketing/PachetSeoSmm";
import PoliticaConfidentialitate from "@/pages/legal/PoliticaConfidentialitate";
import TermeniConditii from "@/pages/legal/TermeniConditii";
import PoliticaCookies from "@/pages/legal/PoliticaCookies";
import BlackDays from "@/pages/BlackDays";
import HoliDeals from "@/pages/HoliDeals";

const AppContent = () => {
  return (
	<div className="app-router">
	  <a href="#main-content" className="skip-link">Skip to main content</a>
	  <header>
		<Header />
	  </header>
	  
	  <main id="main-content">
		<Routes>
		<Route path="/" element={<Home />} />
		<Route path="/contact" element={<Contact />} />
		<Route path="/portfoliu" element={<Portfoliu />} />
		<Route path="/portfoliu/:id" element={<Project />} />
		<Route path="/servicii/web-design/:id" element={<Plan />} />
		<Route path="/servicii/web-design" element={<WebDesign />} />
		<Route path="/servicii/e-commerce" element={<Commerce />} />
		<Route path="/servicii/e-commerce/:id" element={<Plan />} />
		<Route path="/servicii/e-commerce/ccshop-accesadmin" element={<CCshopAdminRequest />} />
		
		{/* ServerSide Tracking */}
		<Route path="/servicii/serverside-tracking" element={<ServerSideTracking />} />
		
		{/* Branding */}
		<Route path="/servicii/branding" element={<Branding />} />
		<Route path="/servicii/branding/logo-design" element={<LogoDesign />} />
		<Route path="/servicii/branding/identitate-vizuala" element={<VisualIdentity />} />
		<Route path="/servicii/branding/manual-branding" element={<ManualBranding />} />
		
		{/* Online Marketing */}
		<Route path="/servicii/online-marketing" element={<OnlineMarketing />} />
		<Route path="/servicii/online-marketing/google-social-setup" element={<SocialSetup />} />
		
		{/* Original SEO/SMM routes (keep for backwards compatibility) */}
		<Route path="/servicii/online-marketing/optimizare-seo" element={<Seo />} />
		<Route path="/servicii/online-marketing/smm-social-media-marketing" element={<Smm />} />
		
		{/* New custom ID routes */}
		<Route path="/servicii/online-marketing/servicii-seo" element={<Seo />} />
		<Route path="/servicii/online-marketing/social-media-marketing" element={<Smm />} />
		<Route path="/servicii/online-marketing/pachet-seo-social-media-marketing" element={<PachetSeoSmm />} />
		
		<Route path="/smm-content" element={<SMMcontent />} />
		<Route path="/servicii/online-marketing/reclame-video" element={<ReclameVideo />} />
		<Route path="/servicii/online-marketing/vfx" element={<VfxVideo />} />
		
					
		<Route path="/portfoliu/e-commerce" element={<Ecommerce />} />
		<Route path="/portfoliu/branding" element={<BrandingPortfolio />} />
		<Route path="/portfoliu/smm-content" element={<SMMcontent />} />
		<Route path="/portfoliu/websiteuri-de-prezentare" element={<WebsiteuriDePrezentare />} />
			
		{/* Legal Pages */}
		<Route path="/politica-confidentialitate" element={<PoliticaConfidentialitate />} />
		<Route path="/termeni-conditii" element={<TermeniConditii />} />
		<Route path="/politica-cookies" element={<PoliticaCookies />} />

		{/* Black Days Campaign */}
		<Route path="/black-days" element={<BlackDays />} />

		{/* SummerDeals Campaign */}
		<Route path="/summerdeals" element={<HoliDeals />} />
		<Route path="/springdeals" element={<Navigate to="/summerdeals" replace />} />
		<Route path="/winterdeals" element={<Navigate to="/summerdeals" replace />} />
		<Route path="/holideals" element={<Navigate to="/summerdeals" replace />} />

		<Route path="*" element={<NotFound />} />
				
		</Routes>
	  </main>
	  
	  <footer>
		<Footer />
	  </footer>
	</div>
  );
};

export default AppContent;
